"use client"
import { useEffect } from "react";
import MapLayout from "@/components/map/map-layout";
import OverlayTransitionWrapper from "@/components/overlay-transition-wrapper/overlay-transition-wrapper";
import RecordsGalleryPage from "@/components/records/records-gallery/records-gallery-page";
import { useApp } from "@/context/AppContext";

export default function MapPage({
  featuredStories,
  allStories,
  introCategory
}) {
  const catId = 'featured';
  const {setRecordCategoryType} = useApp()

  useEffect(() => {
    setRecordCategoryType(false)
  }, [])

  return (
    <OverlayTransitionWrapper
      backgroundContent={
        <RecordsGalleryPage
          catId={catId}
          introCategory={introCategory}
          allCards={allStories}
          introCards={featuredStories}
          isDummy={true}
        />
      }
      overlayContent={
        <div className="w-full font-sans page w-screen h-screen">
          <MapLayout isDummy={true} stories={allStories}/>
        </div>
      }
      mainContent={
        <div className="w-full font-sans page ">
          <MapLayout stories={allStories}/>
        </div>
      }
      overlayClassName='fixed top-0 left-0 w-full h-full z-2000 overflow-hidden'
      overlayInnerClassName='w-full h-full'
    />
  );
}
